import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import EmptyState from "../../components/ui/EmptyState";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { apiRequest, formatPrice } from "../../api/client";
import { useToast } from "../../context/ToastContext";

export default function AdminPromoCodes() {
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  function load() {
    setLoading(true);
    apiRequest("/api/promocodes", { tokenType: "admin" })
      .then((response) => setCodes(response.data))
      .finally(() => setLoading(false));
  }

  useEffect(load, []);

  async function remove(id) {
    if (!window.confirm("Delete this promo code?")) return;
    await apiRequest(`/api/promocodes/${id}`, { method: "DELETE", tokenType: "admin" });
    toast?.show("Promo code deleted.");
    load();
  }

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <div><span className="eyebrow">Discounts</span><h1>Promo Codes</h1></div>
        <Button to="/admin/promocodes/new">Add Promo Code</Button>
      </div>
      {loading ? <LoadingSpinner /> : !codes.length ? <EmptyState title="No promo codes" /> : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Code</th><th>Type</th><th>Value</th><th>Used</th><th>Status</th><th /></tr></thead>
            <tbody>
              {codes.map((code) => (
                <tr key={code.id}>
                  <td><strong>{code.code}</strong><small>{code.name}</small></td>
                  <td>{code.discount_type}</td>
                  <td>{code.discount_type === "fixed" ? formatPrice(code.discount_value) : `${code.discount_value}%`}</td>
                  <td>{code.usage_count}{code.usage_limit ? ` / ${code.usage_limit}` : ""}</td>
                  <td><span className={`status-pill status-${code.active ? "active" : "inactive"}`}>{code.active ? "active" : "inactive"}</span></td>
                  <td className="table-actions">
                    <Link to={`/admin/promocodes/${code.id}/edit`}>Edit</Link>
                    <button type="button" onClick={() => remove(code.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
